import { useTonConnectUI } from "@tonconnect/ui-react"
import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { CurrencyIcon } from "@/helpers/currencyIcon"
import { getCurrencyLabel } from "@/helpers/getCurrencyLabel"
import { numberSpaceFixer } from "@/helpers/numberSpaceFixer"
import { useGetUserDataQuery } from "@/store/apis/userAPI"
import { Button } from "@/ui/Button"
import { ConnectWalletChip } from "../ConnectWalletChip"
import styles from "./WithdrawBalanceCard.module.scss"
import type { IWithdrawBalanceCard } from "./types"

export const WithdrawBalanceCard: FC<IWithdrawBalanceCard> = ({
  currency,
  amount,
  isLoading = false,
  onWithdraw,
  className,
  ...rest
}) => {
  const { t } = useTranslation()
  const [tonConnectUI] = useTonConnectUI()

  const { walletAddress } = useGetUserDataQuery(undefined, {
    selectFromResult: ({ data }) => ({
      walletAddress: data?.wallets?.telegram
    })
  })

  const Icon = CurrencyIcon[currency]

  const handleClick = () => {
    if (walletAddress) {
      onWithdraw(currency)
    } else {
      tonConnectUI.openModal()
    }
  }

  return (
    <div {...rest} className={clsx(styles.WithdrawBalanceCard, className)}>
      <div className={styles.WithdrawBalanceCard_header}>
        <div>
          <div className={styles.WithdrawBalanceCard_label}>
            {t(`wallet.withdraw.card.${currency}Label`)}
          </div>
          <div className={styles.WithdrawBalanceCard_amountRow}>
            {Icon && <Icon />}
            <span className={styles.WithdrawBalanceCard_amount}>
              {isLoading ? "…" : numberSpaceFixer(amount)}
            </span>
            <span className={styles.WithdrawBalanceCard_unit}>
              {getCurrencyLabel(t, currency, amount)}
            </span>
          </div>
        </div>
        <ConnectWalletChip />
      </div>
      <Button
        styles="yellow"
        className={styles.WithdrawBalanceCard_button}
        onClick={() => handleClick()}
      >
        {t(`wallet.withdraw.card.${currency}Button`)}
      </Button>
    </div>
  )
}
